<template>

    <Head title="Verificação Final"></Head>

    <div class="container">
        <div class="row align-items-center mt-10 mb-10 row-logo">
            <div class="col mx-auto text-center">
                <img alt="Logo Habilite-se" src="/habil/images/logo.svg" class="h-35px" />
            </div>
        </div>
        <toastInfo :test_over="props.test_over" :test_middle="props.test_middle" :userName="props.user_name" :userCPF="props.user_cpf" :CFCName="props.subtenant_name" :computerName="props.computer_name" />
        <div class="row align-items-center row-card-final">
            <div class="col-sm-10 col-md-10 mx-auto text-center">
                <div class="card">
                    <div class="card-body" style="padding: 26px 0px 5px 0px">
                        <div class="text-center">
                            <h2 class="m-0">Coleta de Biometria e Foto</h2>
                            <p style="font-size: 15px; color: #747a7e" class="fw-bolder fs-5 text-gray-600">
                                Leia com atenção as instruções de cada etapa
                            </p>
                        </div>
                        <!-- <div class="row justify-content-center mb-2">
                            <div class="col-md-12 fs-3">
                                <div v-if="test_open" class="alert alert-primary mb-0 alert-counter" style="border-radius: 0px">
                                    <strong>Tentativas Restantes:
                                        {{ AttemptsOpen }}</strong>
                                </div>
                                <div v-else-if="test_final" class="alert alert-primary mb-0 alert-counter" style="border-radius: 0px">
                                    <strong>Tentativas Restantes:
                                        {{ AttemptsClose }}</strong>
                                </div>
                            </div>
                        </div> -->
                        <div class="row justify-content-center">
                            <div class="col-md-12">
                                <ul id="progressbar">
                                    <li class="active fs-5" id="biometria">
                                        <strong>Biometria</strong>
                                    </li>
                                    <li class="fs-5 active" id="foto">
                                        <strong>Coleta de Foto</strong>
                                    </li>
                                    <li v-if="props.test_over" class="fs-5 active" id="prova">
                                        <strong>Finalização da Prova</strong>
                                    </li>
                                    <li v-else-if="props.test_middle" class="fs-5 active" id="prova">
                                        <strong>Verificação de Biometria</strong>
                                    </li>
                                    <li v-else class="fs-5 active" id="prova">
                                        <strong>Abertura de Prova</strong>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="row">
                            <p v-if="props.test_over" style="font-size: 15px; color: #747a7e" class="fw-bolder fs-5 text-gray-600 mb-1">
                                Confira sua biometria digital e face.
                                <br />
                                Caso necessário faça o processo novamente ou
                                finalize a sua prova.
                            </p>
                            <p v-else-if="props.test_middle" style="font-size: 15px; color: #747a7e" class="fw-bolder fs-5 text-gray-600 mb-1">
                                Confira sua biometria digital e face.
                                <br />
                                Caso necessário faça o processo novamente e
                                continue sua prova.
                            </p>
                            <p v-else style="font-size: 15px; color: #747a7e" class="fw-bolder fs-5 text-gray-600 mb-1">
                                Confira sua biometria digital e face.
                                <br />
                                Caso necessário faça o processo novamente ou dê
                                inicio a sua prova.
                            </p>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-3">
                                <p style="font-size: 15px; color: #747a7e" class="fw-bolder fs-3 text-gray-600">
                                    Biometria
                                </p>
                                <img :src="biometry" alt="" class="img-preview-final-check" />
                            </div>

                            <div class="col-3">
                                <p style="font-size: 15px; color: #747a7e" class="fw-bolder fs-3 text-gray-600">
                                    Foto
                                </p>
                                <img :src="photo" alt="" class="img-preview-final-check" />
                            </div>
                        </div>
                        <div class="row mt-2 p-5">
                            <div class="col-6">
                                <form :action="props.restartProcess" method="post" class="d-inline">
                                    <button type="submit" id="submit-restart-process" class="btn btn-danger w-100 p-3 btn-sm">
                                        <span class="mx-2 fa fa-lg fa-refresh"></span>
                                        Refazer capturas
                                    </button>
                                </form>
                            </div>
                            <div class="col-6">
                                <button :disabled="buttonLoading" @click="startVerify" id="submit-start-prodesp" class="btn btn-success w-100 p-3 btn-sm">
                                    <span v-if="!buttonLoading" class="mx-2">Iniciar verificação
                                        <span v-if="!detran_integration_enabled">(Sem integração Detran)</span>
                                    </span>
                                    <span v-else class="mx-2">Aguarde um momento...</span>
                                    <span :class="[
                                        buttonLoading
                                            ? 'fas fa-lg fa-sync fa-spin'
                                            : 'fa fa-lg fa-arrow-right',
                                    ]"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, Ref, computed, onMounted } from 'vue';
import axios from 'axios';
import { router } from '@inertiajs/core';
import { commonStore } from '../../stores/common';
import Swal from 'sweetalert2';
import { Head } from '@inertiajs/vue3';
import toastInfo from '../../components/Exam/toast_info.vue'
import { checkConnection } from '../../websockets/WebsocketVerification';
import { browserWebcamStreamingStore } from '../../stores/browserWebcamStreaming';

const common = commonStore();

const props = defineProps({
    photo: { type: String, required: true },
    detran_integration_enabled: { type: Boolean, required: true },
    biometry: { type: String, required: true },
    maximumRetriesOpen: { type: Number, required: true },
    maximumRetriesClose: { type: Number, required: true },
    restartProcess: { type: String, required: true },
    startProcessValidateProdesp: { type: String, required: true },
    routeLogExam: { type: String, required: true },
    enrollmentTestId: { type: Number, required: true },
    test_over: { type: Boolean, required: true },
    test_middle: { type: Boolean, required: true },
    final_exam_id: { type: String, required: true },
    get_biometry_capture_route: { type: String, required: true },
    logout_redirect_route: { type: String, required: true },
    computer_name: { type: String, required: true },
    subtenant_name: { type: String, required: true },
    user_name: { type: String, required: true },
    user_cpf: { type: String, required: true },
    computer_uid: { type: String, required: true },
    is_ws_verification: { type: Boolean, required: true },
    logout_url: { type: String, required: true },
    descricao_computer: { type: String, required: true },
    is_agent_support_ws_verification: { type: Boolean, required: true },
	spa_enabled: { type: Boolean, required: false, default: false },
    browser_webcam_streaming_enabled: { type: Boolean, required: false, default: false },
    open_camera_route: { type: String, required: false, default: '' },
});

const browserWebcam = browserWebcamStreamingStore();
const buttonLoading: Ref<boolean> = ref(false);
const validateStatus: Ref<boolean> = ref(true);
const messageError: Ref<string> = ref('');

const AttemptsOpen: Ref<number> = ref(props.maximumRetriesOpen);
const AttemptsClose: Ref<number> = ref(props.maximumRetriesClose);

const connectionSpinner = ref(true);
const connectionStatus = ref({
    connection: false,
    verified: false,
});

var title: Ref<string> = ref('');
var logDescription: Ref<string> = ref('');
const iconSuccess = `<div style="margin-left:43%; width:50px; height: 50px; border-radius: 80%; background-color: #67c23a;">
            <i class="mt-5 fa fa-check fa-lg" style="color: #ecf5ff;"></i>
        </div>`;
const iconError = `<div style="margin-left:43%; width:50px; height: 50px; border-radius: 80%; background-color: #f56c6c;">
            <i class="mt-5 fa-solid fa-xmark fa-lg" style="color: #ecf5ff;"></i>
        </div>`;

onMounted(() => {
    if (
        props.browser_webcam_streaming_enabled &&
        !browserWebcam.isPublishing &&
        !browserWebcam.isMock
    ) {
        router.get(props.open_camera_route);
        return;
    }

    common.startKeyUp();

    checkConnection(props, connectionStatus, connectionSpinner);

    setInterval(() => {
        checkConnection(props, connectionStatus, connectionSpinner);
    }, 25000);
});

const test_open = computed(() => {
    return !props.test_middle && !props.test_over;
});

const test_final = computed(() => {
    return props.test_over;
});

function goto(url: string) {
	if (props.spa_enabled) {
		router.get(url);
		return;
	}
	window.location.href = url;
}

function startVerify() {
    validateStatus.value = true;
    buttonLoading.value = true;
    axios
        .post(props.startProcessValidateProdesp, {
            enrollment_test_id: props.final_exam_id,
        })
        .then((response) => {
            console.log(response.data.url)
			goto(response.data.url);
        })
        .catch((error) => {
            const response = error.response.data
            messageError.value = response.message;
            validateStatus.value = false;
            buttonLoading.value = false;

            if (test_open.value) {
                AttemptsOpen.value = AttemptsOpen.value - 1;
                title.value = 'Erro na abertura da Prova';
                logDescription.value = '[FALHA ABERTURA DE PROVA] - Houve uma falha ao tentar iniciar a prova';
                console.log(props.final_exam_id)
            }

            if (test_final.value) {
                AttemptsClose.value = AttemptsClose.value - 1;
                title.value = 'Erro no fechamento da Prova';
                logDescription.value = '[FALHA FECHAMENTO DE PROVA] - Falha ao registrar resultado';
            }

            if (error.response.status !== 422) {
                axios.post(props.routeLogExam, {
                    description: logDescription.value,
                    enrollment_test_id: props.enrollmentTestId
                })
                    .catch(function (error) {
                        Swal.fire({
                            html: `
                            ${iconError}
                            <div class="my-4 text-danger">
                                <strong>
                                    'Ocorreu um erro. Tente Novamente!'
                                </strong>
                            </div>
                            Detran: ${messageError.value}
                        `,
                            confirmButtonText: "Confirmar",
                            confirmButtonColor: "#009EF7",
                            allowOutsideClick: false
                        }).then(() => {
							goto(props.get_biometry_capture_route);
                        });
                    });
            }

            Swal.fire({
                html: `
                    ${iconError}
                    <div class="my-4 text-danger">
                        <strong>
                            ${title.value}
                        </strong>
                    </div>
                    Mensagen do Detran: ${messageError.value}
                `,
                confirmButtonText: "Confirmar",
                confirmButtonColor: "#67c23a",
            }).then(() => {
                if (response.should_logout) {
					goto(props.logout_redirect_route)
                } else {
					goto(props.get_biometry_capture_route);
                }
            });
        });
}
</script>
